import React, { useState } from "react";
import HeaderPage from "./header";
import WalletPage from "./wallet_page";
import HomePage from "./home_page";
import HistoryPage from "./history_page";
import ProfilePage from "./profile_page";
import Footer from "./footer";
import { LogoutIcon } from "../../lib/svg_help";

export default function UserInfo({ logoUrl, bannerInfo, colors }) {
  const [selectedTab, setSelectedTab] = useState("home");

  const renderContent = () => {
    switch (selectedTab) {
      case "home":
        return <HomePage bannerInfo={bannerInfo} />;
      case "wallet":
        return <WalletPage colors={colors} />;
      case "history":
        return <HistoryPage colors={colors} />;
      case "profile":
        return <ProfilePage colors={colors} />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div
      style={{
        maxWidth: "60%",
        height: "90vh",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#141414",
      }}
    >
      <HeaderPage logoUrl={logoUrl} />

      <div
        style={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {renderContent()}
      </div>

      <Footer
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        colors={colors}
      />
    </div>
  );
}
